import Typography from "@/ui/atoms/Typography"
import { FormSuccessMessages } from "../../types"
import FadeIn from "@/ui/animations/FadeIn"

export interface CustomFormSuccessProps {
  contents: FormSuccessMessages
}

const CustomFormSuccess = ({ contents }: CustomFormSuccessProps) => {
  return (
    <div className="text-center">
      {contents.illustration && (
        <FadeIn className="mb-4 flex justify-center">
          {contents.illustration}
        </FadeIn>
      )}
      {contents.title && (
        <Typography variant={"h3"} className="mb-3" inheritColor>
          {contents.title}
        </Typography>
      )}
      {contents.message && (
        <Typography variant={"body1"} inheritColor>
          {contents.message}
        </Typography>
      )}
    </div>
  )
}

export default CustomFormSuccess
